import FeatureGrid from "@/components/base/FeatureGrid";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { aboutReasons } from "@/mocks/about";

export default function AboutReasons() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="shell">
        <Reveal>
          <SectionHeading
            eyebrow="Neden d.mar?"
            title="İstanbul'da bizi farklı kılan 5 sebep"
            description="Yüzlerce diş hekiminin düzenli olarak yönlendirdiği bir merkez olmak tesadüf değil; aşağıdaki beş temel özelliğin sonucu."
          />
        </Reveal>

        <div className="mt-14">
          <FeatureGrid items={aboutReasons} columns={3} />
        </div>
      </div>
    </section>
  );
}